import React from 'react'
import AppLayout from '../components/AppLayout'; 
import UserProfile from '../components/UserProfile'; 

const UserProfilePage = () => {
  return (
    <div>
        <AppLayout>
            <UserProfile/>
        </AppLayout>
      
    </div>
  )
}

export default UserProfilePage
